var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('van-nav-bar',{attrs:{"title":"天堂纪念网服务协议","left-arrow":"","fixed":"","z-index":99,"border":false},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"navBarSpace"}),_c('div',{staticClass:"padding"},[(_vm.html)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }